<button *ngIf="form && checkComponent()" matTooltip="Annulla" type="button"
    class="my-bounce btn closeRequestButton mx-2 complaintOpeningWarn" (click)="goTo()">
    {{ 'CHANGESTATEBUTTON.' + 'complaintOpeningButton' | translate }}
</button>